<div class="search-menu-toggle-restrictions">
  <div *ngFor="let restriction of searchContainer.restrictions">
    <mat-checkbox [(ngModel)]="restriction.on"
                  (ngModelChange)="runSearch()">
      <span class="search-menu-toggle-restrictions__text" [translate]="restriction.title"></span>
    </mat-checkbox>
  </div>
</div>
